/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Rankings API
 * API for monthly ranking configs and monthly ranking rows.

Notes:
- Aggregation source: review posts (board_id=review) and their likes/reads.
- Product rankings can be scoped by `parent_category_id`.
- All entities include `created_at` / `updated_at`.

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Get list of ranking configurations.
 * @summary Get ranking config list
 */
export const GetRankingConfigsQueryParams = zod
    .object({
        is_active: zod.number().optional().describe("Filter by active flag"),
    })
    .strict();

export const getRankingConfigs200ResponseDataItemMetricMax = 50;

export const getRankingConfigs200ResponseDataItemScopeMax = 50;

export const getRankingConfigs200ResponseDataItemLimitMax = 100;

export const getRankingConfigs200ResponseDataItemDescriptionThMax = 255;

export const getRankingConfigs200ResponseDataItemDescriptionEnMax = 255;

export const getRankingConfigs200ResponseDataItemDescriptionJaMax = 255;

export const GetRankingConfigs200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        data: zod.array(
            zod
                .object({
                    ranking_config_id: zod.number().describe("Ranking config id"),
                    is_active: zod.number().describe("Active flag"),
                    ranking_type: zod.enum(["product", "user"]),
                    metric: zod.string().max(getRankingConfigs200ResponseDataItemMetricMax),
                    scope: zod.string().max(getRankingConfigs200ResponseDataItemScopeMax),
                    limit: zod
                        .number()
                        .min(1)
                        .max(getRankingConfigs200ResponseDataItemLimitMax)
                        .describe("Number of records to output (e.g. 30)"),
                    description_th: zod
                        .string()
                        .max(getRankingConfigs200ResponseDataItemDescriptionThMax)
                        .optional()
                        .describe("Ranking config description in Thai"),
                    description_en: zod
                        .string()
                        .max(getRankingConfigs200ResponseDataItemDescriptionEnMax)
                        .optional()
                        .describe("Ranking config description in English"),
                    description_ja: zod
                        .string()
                        .max(getRankingConfigs200ResponseDataItemDescriptionJaMax)
                        .optional()
                        .describe("Ranking config description in Japanese"),
                    ui_label: zod
                        .string()
                        .optional()
                        .describe("UI helper label derived from ranking type, metric, and scope"),
                    ui_description: zod.string().optional().describe("Localized UI helper description"),
                    created_at: zod.string().datetime({ offset: true }),
                    updated_at: zod.string().datetime({ offset: true }),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                current_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

export const GetRankingConfigs400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetRankingConfigs500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

/**
 * Get monthly aggregated rankings.

- If `month` is omitted, default is previous month.
- Use `parent_category_id` to scope product ranking to a parent category.
- `parent_category_ids` is accepted as a multi-value alias.

 * @summary Get aggregated rankings
 */
export const getRankingsQueryMonthRegExp = new RegExp("^\\d{4}-\\d{2}$");
export const getRankingsQueryPageDefault = 1;

export const getRankingsQueryPerPageDefault = 30;
export const getRankingsQueryPerPageMax = 100;

export const getRankingsQuerySortDefault = `rank`;
export const getRankingsQueryOrderDefault = `asc`;

export const GetRankingsQueryParams = zod
    .object({
        month: zod
            .string()
            .regex(getRankingsQueryMonthRegExp)
            .optional()
            .describe("Target month (YYYY-MM). Default: previous month"),
        ranking_config_id: zod.number().describe("Filter by ranking_config_id"),
        parent_category_id: zod
            .number()
            .nullish()
            .describe("Filter by parent category id (for category-scoped rankings)"),
        parent_category_ids: zod
            .union([zod.number(), zod.string(), zod.array(zod.number())])
            .optional()
            .describe("Alias of `parent_category_id` (supports multiple values)"),
        page: zod.number().min(1).default(getRankingsQueryPageDefault).describe("Page number for pagination"),
        per_page: zod
            .number()
            .min(1)
            .max(getRankingsQueryPerPageMax)
            .default(getRankingsQueryPerPageDefault)
            .describe("Number of items per page"),
        sort: zod
            .enum(["rank", "metric_value", "created_at", "updated_at"])
            .default(getRankingsQuerySortDefault)
            .describe("Sort field"),
        order: zod.enum(["asc", "desc"]).default(getRankingsQueryOrderDefault).describe("Sort order"),
    })
    .strict();

export const getRankings200ResponseDataItemOneTargetMonthMax = 7;

export const getRankings200ResponseDataItemOneTargetMonthRegExp = new RegExp("^\\d{4}-\\d{2}$");

export const getRankings200ResponseDataItemOneEntityTypeMax = 50;

export const getRankings200ResponseDataItemTwoProductOneProductNameMax = 255;

export const getRankings200ResponseDataItemTwoProductOneBrandNameMax = 100;

export const getRankings200ResponseDataItemTwoProductOnePriceUnitMax = 10;

export const getRankings200ResponseDataItemTwoProductOneUnitMax = 100;

export const getRankings200ResponseDataItemTwoProductOneCategoryNameMax = 100;

export const getRankings200ResponseDataItemTwoProductOneParentCategoryNameMax = 100;

export const getRankings200ResponseDataItemTwoProductOneCategoryCategoryNameMax = 100;

export const getRankings200ResponseDataItemTwoProductOneCategoryCategoryIconMax = 40;

export const getRankings200ResponseDataItemTwoProductOneCategoryParentCategoryNameMax = 100;

export const getRankings200ResponseDataItemTwoUserOneDisplayNameMax = 50;

export const getRankings200ResponseDataItemTwoUserOneFirstNameMax = 100;

export const getRankings200ResponseDataItemTwoUserOneLastNameMax = 100;

export const getRankings200ResponseDataItemTwoUserOneNickNameMax = 50;

export const getRankings200ResponseDataItemTwoUserOneAvatarMax = 255;

export const GetRankings200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        data: zod.array(
            zod
                .object({
                    ranking_id: zod.number().describe("Ranking id"),
                    ranking_config_id: zod.number().describe("Related ranking_config_id"),
                    target_month: zod
                        .string()
                        .max(getRankings200ResponseDataItemOneTargetMonthMax)
                        .regex(getRankings200ResponseDataItemOneTargetMonthRegExp)
                        .describe("Target month (YYYY-MM)"),
                    parent_category_id: zod.number().nullish().describe("Parent category id when scoped"),
                    rank: zod.number().min(1).describe("1-based rank"),
                    entity_type: zod.string().max(getRankings200ResponseDataItemOneEntityTypeMax),
                    entity_id: zod.number().describe("product_id or user_id depending on ranking_type"),
                    metric_value: zod.number().describe("Value for the selected metric in the month"),
                    created_at: zod.string().datetime({ offset: true }),
                    updated_at: zod.string().datetime({ offset: true }),
                    entity_label: zod.string().nullish().describe("Display label derived from joined entity"),
                    entity_url: zod.string().nullish().describe("Canonical URL to the entity detail page"),
                    parent_category_label: zod.string().nullish().describe("Label of parent category when available"),
                    product: zod
                        .union([
                            zod
                                .object({
                                    product_id: zod.number(),
                                    product_status: zod
                                        .enum([
                                            "draft",
                                            "editing",
                                            "released",
                                            "duplicated",
                                            "rejected",
                                            "dummy",
                                            "brand",
                                        ])
                                        .optional(),
                                    product_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoProductOneProductNameMax),
                                    product_url: zod.string().optional(),
                                    image: zod.string().optional(),
                                    category_id: zod.number().nullish(),
                                    brand_id: zod.number().nullish(),
                                    brand_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoProductOneBrandNameMax)
                                        .optional()
                                        .describe("Brand name (enriched for UI)"),
                                    average_rating: zod.number().nullish(),
                                    review_count: zod.number().nullish(),
                                    likes_count: zod.number().nullish(),
                                    reads_count: zod.number().nullish(),
                                    price: zod.number().nullish(),
                                    price_unit: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoProductOnePriceUnitMax)
                                        .optional(),
                                    unit: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoProductOneUnitMax)
                                        .optional(),
                                    recommend_rank: zod.number().nullish(),
                                    monthly_rank: zod.number().nullish(),
                                    rank: zod.number().optional(),
                                    category_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoProductOneCategoryNameMax)
                                        .optional(),
                                    parent_category_id: zod.number().nullish(),
                                    parent_category_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoProductOneParentCategoryNameMax)
                                        .optional(),
                                    category: zod
                                        .object({
                                            category_id: zod.number().nullish(),
                                            category_name: zod
                                                .string()
                                                .max(getRankings200ResponseDataItemTwoProductOneCategoryCategoryNameMax)
                                                .optional(),
                                            category_icon: zod
                                                .string()
                                                .max(getRankings200ResponseDataItemTwoProductOneCategoryCategoryIconMax)
                                                .optional()
                                                .describe(
                                                    "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                                ),
                                            parent_category_id: zod.number().nullish(),
                                            parent_category_name: zod
                                                .string()
                                                .max(
                                                    getRankings200ResponseDataItemTwoProductOneCategoryParentCategoryNameMax,
                                                )
                                                .optional(),
                                            display_order: zod.number().optional(),
                                            review_config_id: zod.number().optional(),
                                            products_count: zod.number().optional(),
                                            is_active: zod.number().optional(),
                                            created_at: zod.string().datetime({ offset: true }).optional(),
                                            updated_at: zod.string().datetime({ offset: true }).optional(),
                                        })
                                        .strict()
                                        .nullish(),
                                    created_at: zod.string().datetime({ offset: true }).optional(),
                                    updated_at: zod.string().datetime({ offset: true }).optional(),
                                })
                                .strict()
                                .describe("Minimal product payload for rankings"),
                            zod.null(),
                        ])
                        .optional()
                        .describe("Joined product payload when entity_type=product"),
                    user: zod
                        .union([
                            zod
                                .object({
                                    user_id: zod.number(),
                                    display_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoUserOneDisplayNameMax),
                                    first_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoUserOneFirstNameMax)
                                        .optional(),
                                    last_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoUserOneLastNameMax)
                                        .optional(),
                                    nick_name: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoUserOneNickNameMax)
                                        .optional(),
                                    avatar: zod
                                        .string()
                                        .max(getRankings200ResponseDataItemTwoUserOneAvatarMax)
                                        .optional(),
                                    posts_count: zod.number().nullish(),
                                    followers_count: zod.number().optional(),
                                    followings_count: zod.number().optional(),
                                    point: zod
                                        .number()
                                        .optional()
                                        .describe("Points earned from point rules during the ranking month"),
                                    created_at: zod.string().datetime({ offset: true }).optional(),
                                    updated_at: zod.string().datetime({ offset: true }).optional(),
                                    skin_type: zod
                                        .enum([
                                            "normal",
                                            "oily",
                                            "dry",
                                            "combination",
                                            "sensitive",
                                            "dehydrated_oily",
                                            "not_sure",
                                        ])
                                        .nullish()
                                        .describe("Skin type (preference profile)"),
                                    skin_concerns: zod
                                        .array(
                                            zod.enum([
                                                "acne",
                                                "pores",
                                                "blackheads",
                                                "whiteheads",
                                                "dark_spots",
                                                "redness",
                                                "wrinkles",
                                                "dullness",
                                            ]),
                                        )
                                        .nullish()
                                        .describe("Skin concerns (multiple selection)"),
                                })
                                .strict()
                                .describe("Minimal public-safe user payload for rankings"),
                            zod.null(),
                        ])
                        .optional()
                        .describe("Joined user payload when entity_type=user"),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                current_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

export const GetRankings400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetRankings500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

/**
 * Fetch product rankings for the month in one request.

Intended for Rankings UI where parent category is switched client-side.
Use `parent_category_id` when fetching only specific parent category buckets.

 * @summary Bulk get product rankings for month
 */
export const getBulkProductRankingsQueryMonthRegExp = new RegExp("^\\d{4}-\\d{2}$");
export const getBulkProductRankingsQueryLimitDefault = 10;
export const getBulkProductRankingsQueryLimitMax = 100;

export const GetBulkProductRankingsQueryParams = zod
    .object({
        month: zod
            .string()
            .regex(getBulkProductRankingsQueryMonthRegExp)
            .optional()
            .describe("Target month (YYYY-MM). Default: previous month"),
        limit: zod
            .number()
            .min(1)
            .max(getBulkProductRankingsQueryLimitMax)
            .default(getBulkProductRankingsQueryLimitDefault)
            .describe("Top N rows to return per config\/category"),
        parent_category_id: zod.number().nullish().describe("Filter result buckets by parent category id"),
        parent_category_ids: zod
            .union([zod.number(), zod.string(), zod.array(zod.number())])
            .optional()
            .describe("Alias of `parent_category_id` (supports multiple values)"),
    })
    .strict();

export const getBulkProductRankings200ResponseDataConfigsItemMetricMax = 50;

export const getBulkProductRankings200ResponseDataConfigsItemScopeMax = 50;

export const getBulkProductRankings200ResponseDataConfigsItemLimitMax = 100;

export const getBulkProductRankings200ResponseDataConfigsItemDescriptionThMax = 255;

export const getBulkProductRankings200ResponseDataConfigsItemDescriptionEnMax = 255;

export const getBulkProductRankings200ResponseDataConfigsItemDescriptionJaMax = 255;

export const GetBulkProductRankings200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        data: zod
            .object({
                month: zod.string(),
                limit: zod.number(),
                configs: zod.array(
                    zod
                        .object({
                            ranking_config_id: zod.number().describe("Ranking config id"),
                            is_active: zod.number().describe("Active flag"),
                            ranking_type: zod.enum(["product", "user"]),
                            metric: zod.string().max(getBulkProductRankings200ResponseDataConfigsItemMetricMax),
                            scope: zod.string().max(getBulkProductRankings200ResponseDataConfigsItemScopeMax),
                            limit: zod
                                .number()
                                .min(1)
                                .max(getBulkProductRankings200ResponseDataConfigsItemLimitMax)
                                .describe("Number of records to output (e.g. 30)"),
                            description_th: zod
                                .string()
                                .max(getBulkProductRankings200ResponseDataConfigsItemDescriptionThMax)
                                .optional()
                                .describe("Ranking config description in Thai"),
                            description_en: zod
                                .string()
                                .max(getBulkProductRankings200ResponseDataConfigsItemDescriptionEnMax)
                                .optional()
                                .describe("Ranking config description in English"),
                            description_ja: zod
                                .string()
                                .max(getBulkProductRankings200ResponseDataConfigsItemDescriptionJaMax)
                                .optional()
                                .describe("Ranking config description in Japanese"),
                            ui_label: zod
                                .string()
                                .optional()
                                .describe("UI helper label derived from ranking type, metric, and scope"),
                            ui_description: zod.string().optional().describe("Localized UI helper description"),
                            created_at: zod.string().datetime({ offset: true }),
                            updated_at: zod.string().datetime({ offset: true }),
                        })
                        .strict(),
                ),
                parent_categories: zod.array(
                    zod
                        .object({
                            parent_category_id: zod.number().nullable(),
                            category_id: zod.number().nullable().describe("Deprecated alias of `parent_category_id`"),
                            label: zod.string(),
                        })
                        .strict(),
                ),
                rankings: zod
                    .record(zod.string(), zod.unknown())
                    .describe("Map of parent_category_id -> ranking_config_id -> rows"),
            })
            .strict(),
    })
    .strict();

export const GetBulkProductRankings400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetBulkProductRankings500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

/**
 * Fetch user rankings for the month in one request.

 * @summary Bulk get user rankings for month
 */
export const getBulkUserRankingsQueryMonthRegExp = new RegExp("^\\d{4}-\\d{2}$");
export const getBulkUserRankingsQueryLimitDefault = 10;
export const getBulkUserRankingsQueryLimitMax = 100;

export const GetBulkUserRankingsQueryParams = zod
    .object({
        month: zod
            .string()
            .regex(getBulkUserRankingsQueryMonthRegExp)
            .optional()
            .describe("Target month (YYYY-MM). Default: previous month"),
        limit: zod
            .number()
            .min(1)
            .max(getBulkUserRankingsQueryLimitMax)
            .default(getBulkUserRankingsQueryLimitDefault)
            .describe("Top N rows to return per config"),
    })
    .strict();

export const getBulkUserRankings200ResponseDataConfigsItemMetricMax = 50;

export const getBulkUserRankings200ResponseDataConfigsItemScopeMax = 50;

export const getBulkUserRankings200ResponseDataConfigsItemLimitMax = 100;

export const getBulkUserRankings200ResponseDataConfigsItemDescriptionThMax = 255;

export const getBulkUserRankings200ResponseDataConfigsItemDescriptionEnMax = 255;

export const getBulkUserRankings200ResponseDataConfigsItemDescriptionJaMax = 255;

export const GetBulkUserRankings200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        data: zod
            .object({
                month: zod.string(),
                limit: zod.number(),
                configs: zod.array(
                    zod
                        .object({
                            ranking_config_id: zod.number().describe("Ranking config id"),
                            is_active: zod.number().describe("Active flag"),
                            ranking_type: zod.enum(["product", "user"]),
                            metric: zod.string().max(getBulkUserRankings200ResponseDataConfigsItemMetricMax),
                            scope: zod.string().max(getBulkUserRankings200ResponseDataConfigsItemScopeMax),
                            limit: zod
                                .number()
                                .min(1)
                                .max(getBulkUserRankings200ResponseDataConfigsItemLimitMax)
                                .describe("Number of records to output (e.g. 30)"),
                            description_th: zod
                                .string()
                                .max(getBulkUserRankings200ResponseDataConfigsItemDescriptionThMax)
                                .optional()
                                .describe("Ranking config description in Thai"),
                            description_en: zod
                                .string()
                                .max(getBulkUserRankings200ResponseDataConfigsItemDescriptionEnMax)
                                .optional()
                                .describe("Ranking config description in English"),
                            description_ja: zod
                                .string()
                                .max(getBulkUserRankings200ResponseDataConfigsItemDescriptionJaMax)
                                .optional()
                                .describe("Ranking config description in Japanese"),
                            ui_label: zod
                                .string()
                                .optional()
                                .describe("UI helper label derived from ranking type, metric, and scope"),
                            ui_description: zod.string().optional().describe("Localized UI helper description"),
                            created_at: zod.string().datetime({ offset: true }),
                            updated_at: zod.string().datetime({ offset: true }),
                        })
                        .strict(),
                ),
                rankings: zod.record(zod.string(), zod.unknown()).describe("Map of ranking_config_id -> rows"),
            })
            .strict(),
    })
    .strict();

export const GetBulkUserRankings400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetBulkUserRankings500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();
